import { useState } from 'react'
import AdminApi from './../../api/admin-api/admin-api'

export const FALLBACK_RECRUITING_LINK = 'https://careers.usabg.com/usabginterview'

const useRecruitingInterview = () => {
  const [loading, setLoading] = useState(false)

  const goToInterview = async event => {
    if (event) event.preventDefault()
    if (loading) return

    setLoading(true)

    let url = FALLBACK_RECRUITING_LINK

    try {
      const res = await AdminApi.getRecruitingInterviewUrl()
      if (res && res.data && res.data.url) url = res.data.url
    } catch (e) {
      console.error('Unable to resolve recruiting interview URL:', e)
    }

    window.location.href = url
  }

  return { loading, goToInterview }
}

export default useRecruitingInterview
